import { NotificationType } from './NotificationItem';

/** 헤더 알림 패널을 외부에서 열 때 사용하는 커스텀 이벤트명 */
export const OPEN_NOTIFICATIONS_EVENT = 'azflow:open-notifications';

export interface OpenNotificationsDetail {
  tab?: NotificationType;
}

/** 헤더 알림 패널을 지정 탭으로 연다 */
export const openNotificationsPanel = (tab: NotificationType = NotificationType.TASK) => {
  window.dispatchEvent(
    new CustomEvent<OpenNotificationsDetail>(OPEN_NOTIFICATIONS_EVENT, {
      detail: { tab },
    })
  );
};
